import { motion } from "framer-motion";
import { useMemo } from "react";
import { useTheme } from "units/dashboard/context/ThemeProvider";

const AnimatedBackground = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  const particles = useMemo(() => {
    return Array.from({ length: 40 }, () => ({
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      duration: 4 + Math.random() * 5,
      delay: Math.random() * 2,
    }));
  }, []);

  const blobs = useMemo(
    () => [
      {
        size: "w-[500px] h-[500px]",
        position: "top-[-180px] left-[-150px]",
        lightColor: "bg-teal-400",
        darkColor: "bg-teal-900",
        delay: 0,
      },
      {
        size: "w-[450px] h-[450px]",
        position: "bottom-[-150px] right-[-120px]",
        lightColor: "bg-teal-400",
        darkColor: "bg-teal-900",
        delay: 2,
      },
      {
        size: "w-[350px] h-[350px]",
        position: "top-[35%] left-[45%]",
        lightColor: "bg-yellow-300",
        darkColor: "bg-yellow-900",
        delay: 4,
      },
    ],
    []
  );

  return (
    <div
      className={`
        fixed inset-0 overflow-hidden -z-10
        pointer-events-none
        transition-colors duration-700
        ${isDark
          ? "bg-gradient-to-br from-[#061c1a] via-[#071514] to-[#191500]"
          : "bg-gradient-to-br from-[#f8faf5] via-white to-[#fff8df]"
        }
      `}
    >
      {blobs.map((blob, index) => (
        <motion.div
          key={index}
          className={`
            absolute rounded-full blur-[90px]
            opacity-60
            ${blob.size}
            ${blob.position}
            ${isDark ? blob.darkColor : blob.lightColor}
          `}
          animate={{
            x: [0, 120, -80, 0],
            y: [0, -80, 100, 0],
            scale: [1, 1.25, 0.85, 1],
          }}
          transition={{
            duration: 16,
            repeat: Infinity,
            ease: "easeInOut",
            delay: blob.delay,
          }}
        />
      ))}

      {particles.map((p, i) => (
        <motion.span
          key={i}
          className={`
            absolute w-1.5 h-1.5 rounded-full
            opacity-40
            ${isDark ? "bg-teal-400" : "bg-teal-600"}
          `}
          style={{ left: p.left, top: p.top }}
          animate={{
            y: [0, -60, 0],
            opacity: [0.2, 0.7, 0.2],
          }}
          transition={{
            duration: p.duration,
            repeat: Infinity,
            delay: p.delay,
          }}
        />
      ))}

      {isDark && (
        <>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(20,184,166,0.06),transparent_60%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(250,204,21,0.05),transparent_30%)]" />
        </>
      )}
    </div>
  );
};

export default AnimatedBackground;